<div class="loading-overlay" *ngIf="show" [@fade]>
  <div class="overlay"></div>
  <div class="spin d-flex justify-content-center align-items-center">
    <i class="fa fa-spinner fa-spin fa-fw"></i>
    <span *ngIf="msg" class="ml-2">{{msg}}</span>
  </div>
</div>